import { motion } from "framer-motion";
import { Button } from "@cakrawalajakarta/shared-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCalendarCheck,
  faLocationDot,
  faShirt,
  faStore,
} from "@fortawesome/free-solid-svg-icons";

const TIENTO_URL = "https://tiento.co.id/pages/jotr2026";

const products = [
  {
    label: "T-Shirt",
    title: "T-Shirt JOTR 2026",
    description: "Kaos style list bisa dipakai casual atau olahraga.",
    image:
      "https://tiento.co.id/cdn/shop/files/combined-image_22.jpg?v=1783419204&width=900",
  },
  {
    label: "Jersey",
    title: "Long Sleeve JOTR 2026",
    description:
      "Bebas bergerak, breathable, melindungi tangan sampai pergelangan.",
    image:
      "https://tiento.co.id/cdn/shop/files/LongSleeve_1.jpg?v=1783416865&width=900",
  },
  {
    label: "Topi",
    title: "Topi JOTR 2026",
    description:
      "Menghalang panas, memberi kesan teduh, melindungi permukaan leher.",
    image:
      "https://tiento.co.id/cdn/shop/files/TopiJOTR.jpg?v=1783414578&width=900",
  },
];

export const Tiento = () => {
  const openTiento = () => {
    window.location.href = TIENTO_URL;
  };

  return (
    <section className="w-full min-h-screen py-20 text-lime-600 flex-col justify-center relative bg-white">
      <div className="relative z-0 container mx-auto px-4">
        <div className="max-w-7xl mx-auto space-y-8">
          <motion.div
            className="rounded-2xl border border-gray-200 bg-white p-4 text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            viewport={{ once: true }}
          >
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-center">
              <div className="lg:col-span-6 py-4">
                <div className="inline-flex w-fit items-center gap-2 rounded-full bg-lime-50 border border-lime-100 px-4 py-2 text-xs font-bold uppercase tracking-wider text-lime-700 mb-5">
                  <FontAwesomeIcon icon={faStore} className="text-lime-600" />
                  Official Merchandise
                </div>

                <p className="text-sm font-bold uppercase tracking-wider text-gray-500">
                  JOTR 2026 x Tiento
                </p>

                <h1 className="max-w-3xl text-4xl md:text-6xl font-black uppercase leading-tight text-lime-600 mt-3">
                  Official Race Merchandise
                </h1>

                <p className="text-base md:text-lg text-gray-600 leading-relaxed mt-5 max-w-2xl">
                  Koleksi apparel resmi untuk race weekend Cibodas. T-shirt,
                  jersey, dan topi edisi terbatas tersedia di katalog resmi
                  Tiento.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 mt-7">
                  <Button
                    onClick={openTiento}
                    className="uppercase tracking-wider"
                  >
                    Lihat Koleksi
                    <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={openTiento}
                    className="uppercase tracking-wider"
                  >
                    Buka Tiento
                  </Button>
                </div>
              </div>

              <div className="lg:col-span-6">
                <div className="grid grid-cols-5 gap-4">
                  <div className="col-span-5 overflow-hidden rounded-2xl bg-gray-100 sm:col-span-3">
                    <div className="aspect-[4/5]">
                      <img
                        src="https://tiento.co.id/cdn/shop/files/RGA03462.jpg?v=1783402189&width=1000"
                        alt="JOTR 2026 official merchandise by Tiento"
                        className="h-full w-full object-cover"
                      />
                    </div>
                  </div>
                  <div className="col-span-5 grid grid-cols-2 gap-4 sm:col-span-2 sm:grid-cols-1">
                    <div className="overflow-hidden rounded-2xl bg-gray-100">
                      <img
                        src="https://tiento.co.id/cdn/shop/files/combined-image_22.jpg?v=1783419204&width=600"
                        alt="T-Shirt JOTR 2026"
                        className="h-full min-h-36 w-full object-cover"
                      />
                    </div>
                    <div className="overflow-hidden rounded-2xl bg-gray-100">
                      <img
                        src="https://tiento.co.id/cdn/shop/files/TopiJOTR.jpg?v=1783414578&width=600"
                        alt="Topi JOTR 2026"
                        className="h-full min-h-36 w-full object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="rounded-2xl border border-gray-200 bg-lime-50 px-4 py-3">
                <div className="flex items-center gap-3 text-lime-600 font-bold">
                  <FontAwesomeIcon icon={faCalendarCheck} />
                  Pickup Date
                </div>
                <p className="text-sm text-gray-600 mt-1">
                  July 24 - 25, 2026
                </p>
              </div>
              <div className="rounded-2xl border border-gray-200 bg-lime-50 px-4 py-3">
                <div className="flex items-center gap-3 text-lime-600 font-bold">
                  <FontAwesomeIcon icon={faLocationDot} />
                  Booth Tiento
                </div>
                <p className="text-sm text-gray-600 mt-1">
                  Kebun Raya Cibodas BRIN
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="bg-lime-50 rounded-2xl border border-lime-100 px-4 py-8 text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            viewport={{ once: true }}
          >
            <div className="max-w-4xl mx-auto">
              <div className="inline-flex items-center gap-2 text-lime-600 font-bold uppercase tracking-wider text-sm mb-3">
                <FontAwesomeIcon icon={faShirt} />
                Brand Manifesto
              </div>
              <h2 className="text-3xl md:text-5xl font-black text-lime-600 uppercase">
                Hanya untuk yang berani bertahan.
              </h2>
              <p className="text-gray-600 text-base md:text-lg leading-relaxed mt-4">
                Jakarta Open Trail Run bukanlah fun run biasa. Dan merchandise
                ini bukanlah sekadar apparel. Tiento menghadirkan Special
                Edition Official Merchandise JOTR dengan standar performa
                tinggi.
              </p>
            </div>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {products.map((product, index) => (
              <motion.a
                href={TIENTO_URL}
                key={product.title}
                className="group bg-white rounded-2xl p-4 border border-gray-200 text-left overflow-hidden transition hover:border-lime-300 hover:shadow-lg"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  delay: index * 0.08,
                  ease: "easeInOut",
                }}
                viewport={{ once: true }}
              >
                <div className="aspect-square rounded-2xl overflow-hidden bg-gray-100">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="mt-5 inline-flex rounded-full bg-lime-100 px-3 py-1 text-xs font-bold uppercase tracking-wider text-lime-700">
                  {product.label}
                </div>
                <h3 className="text-xl md:text-2xl font-black text-lime-800 uppercase mt-3">
                  {product.title}
                </h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed mt-2">
                  {product.description}
                </p>
              </motion.a>
            ))}
          </div>

          <motion.div
            className="bg-white rounded-2xl border border-gray-200 px-4 py-8 text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            viewport={{ once: true }}
          >
            <h2 className="text-2xl md:text-4xl font-black text-lime-600 uppercase">
              Lihat seleksi apparel JOTR 2026 sekarang
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto mt-3 leading-relaxed">
              Temukan pilihan warna, detail tipe potongan, serta panduan ukuran
              lengkap langsung di halaman koleksi resmi Tiento.
            </p>
            <Button
              onClick={openTiento}
              className="mt-7 uppercase tracking-wider"
            >
              Lihat Daftar Apparel
              <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
